import { RpcAzureOperationResult } from './rpc-azure-model';

/**
 * Rpc azure response handler interface.
 */
export interface RpcAzureResponseHandler {
    handler(data: RpcAzureOperationResult): Promise<void>;
}
